import type { RouteRecordRaw } from 'vue-router'

import { routeMarketingCampaignsRoot } from '@/routers/routes/mainRoutes/routeMarketing/marketingCampaignRoutes'
import {
  routeMarketingDashboardHome,
  routeMarketingDashboardRoot,
} from '@/routers/routes/mainRoutes/routeMarketing/marketingDashboardRoutes'
import { routeNewsletterRoot } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter'

const routeMarketingHome: RouteRecordRaw = {
  name: 'marketing',
  path: '',
  redirect: routeMarketingDashboardHome,
}

const routeMarketingRoot: RouteRecordRaw = {
  children: [
    routeMarketingHome,
    routeNewsletterRoot,
    routeMarketingCampaignsRoot,
    routeMarketingDashboardRoot,
  ],

  path: 'marketing',
}

export { routeMarketingRoot }
